module.exports = __webpack_public_path__ + "media/assets/images/tour/2_Tour_3-65edf36c106f1d4a90017e059062abf4.png";